require('dotenv').config()

export default {
  CLIENT_ID:
    process.env.REACT_APP_AMAZON_CLIENT_ID || '5q4jj9sqi8mhsv7uskuv3j70n0',
  URL_ADMIN_SET_USER_PASSWORD:
    process.env.REACT_APP_URL_ADMIN_SET_USER_PASSWORD ||
    'https://accounts.errepar.com/eauth/eAuth/setPassword',
  URL_NOTIFY_USER_EAUTH_CAC:
    process.env.REACT_APP_URL_NOTIFY_USER_EAUTH_CAC ||
    'https://accounts.errepar.com/eauth/eAuth/authCAC/notifyLoginUserEAuthCAC',
  URL_VERIFY_USER_COGNITO_CAC:
    process.env.REACT_APP_URL_VERIFY_USER_COGNITO_CAC ||
    'https://accounts.errepar.com/eauth/auth/getUserCAC/verifyUserCognito',
  KEY_JOBS: process.env.REACT_APP_KEY_JOBS || 'secret',
  URL_JOBS_EAUTH:
    process.env.REACT_APP_URL_JOBS_EAUTH ||
    'https://accounts.errepar.com/eauth/auth/job/getJobCredentialsEAuth',
  URL_GENERATE_JWT3: 'https://accounts.uat.errepar.com/syserrepar/integration/authenticationandauthorization/e-auth-api/eauth/auth/generateJwt3'

}
